import { DeliveryAppLocale, LocalisedString } from '@provider-portal/common/api/types';

export function getLocalisedStringValue(localisedString: LocalisedString | null): string | null {
  return localisedString ? localisedString.value : null;
}

export function getLocalisedStringValueOrEmpty(localisedString: LocalisedString | null): string {
  return localisedString ? localisedString.value : '';
}

export const getLocaleThatSupportedByApp = (
  appLocales: DeliveryAppLocale[],
  desiredLocales: string[],
): string | undefined => {
  return desiredLocales.find((locale) =>
    appLocales?.map((appLocale) => appLocale.locale).includes(locale as any),
  );
};
